import React, { useState, useRef, useEffect } from "react";
import { RiArrowDropDownLine } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  setBalanceSheetForm,
  setProfitAndLossForm,
} from "../../redux/features/accountingSlice";
import { showReportForm } from "../../redux/features/transactionSlice";
import { showReportForm as equityReportForm } from "../../redux/features/equitySlice";
const NavAccounting = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const permissions = useSelector((state) => state.auth.permissions);

  const dispatch = useDispatch();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={toggleDropdown}
        className="flex hover:text-white font-bold p-1"
      >
        حسابداری
        <RiArrowDropDownLine size={24} />
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-40 bg-white border border-gray-300 rounded shadow-md z-50">
          {permissions["view accounts"] && (
            <Link
              to="/accounts"
              className="block px-4 py-1 text-gray-800 hover:bg-gray-200"
            >
              حسابات
            </Link>
          )}
          <Link
            to="/equities"
            className="block px-4 py-1 text-gray-800 hover:bg-gray-200"
          >
            سهام
          </Link>
          <hr />
          <button
            onClick={() => dispatch(setBalanceSheetForm())}
            className="block w-full text-start px-4 py-1 text-gray-800 hover:bg-gray-200"
          >
            ترازنامه
          </button>
          <button
            onClick={() => dispatch(setProfitAndLossForm())}
            className="block w-full text-start px-4 py-1 text-gray-800 hover:bg-gray-200"
          >
            سود و زیان
          </button>

          <hr />
          {permissions["view accounts"] && (
            <Link
              to="/accounting/journal-items"
              className="block px-4 py-1 text-gray-800 hover:bg-gray-200"
            >
              روزنامچه
            </Link>
          )}
          <hr />
          <button
            onClick={() => dispatch(showReportForm())}
            className="block w-full text-start px-4 py-1 text-gray-800 hover:bg-gray-200"
          >
            گذارش تبادلات نقدینگی
          </button>
          <hr />
          <button
            onClick={() => dispatch(equityReportForm())}
            className="block w-full text-start px-4 py-1 text-gray-800 hover:bg-gray-200"
          >
            گذارش سهام
          </button>
        </div>
      )}
    </div>
  );
};

export default NavAccounting;
